import { Component, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { BaseFormComponent, FormManagerService } from '@sim/form';

import { EMPTY, of } from 'rxjs';

import { UserModuleConfiguration } from '@sim/users/models/configuration';
import { User, UserMeta } from '@sim/users/models/user';
import { UsersApiService } from '@sim/users/services/users-api.service';
import { UserConfigurationService } from '@sim/users/token';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'app-user-manager',
  styleUrls: ['./user-manager.component.scss'],
  templateUrl: './user-manager.component.html',
})
export class UserManagerComponent extends BaseFormComponent<User> {

  readonly passwordControl = new UntypedFormControl();

  readonly roles$ = typeof this.config.roles === 'function'
    ? this.config.roles()
    : of(this.config.roles || []);

  constructor(
    protected readonly translate: TranslateService,
    protected readonly spinner: NgxSpinnerService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly route: ActivatedRoute,
    protected readonly formManager: FormManagerService,
    protected readonly userApi: UsersApiService,
    protected readonly router: Router,
    @Inject(UserConfigurationService) private readonly config: UserModuleConfiguration,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      undefined,
      UserMeta,
      ((id) => userApi.get(id as string)),
      '/users',
      router,
    );

    if (!this.entityId) {
      this.passwordControl.setValidators(Validators.required);
    }
  }

  addConcrete(user: User) {
    if (!this.passwordControl.valid) {
      return EMPTY;
    }

    const noEncryptPassword = this.passwordControl.value;
    const password = Md5.hashStr(noEncryptPassword) as string;

    const postUser: User = { ...user, password };

    return this.userApi.post(postUser);
  }

  removeConcrete(user: User) {
    if (user.id) {
      return this.userApi.remove(user.id);
    }
    return EMPTY;
  }

  editConcrete(user: User) {
    const password = this.passwordControl.value ? Md5.hashStr(this.passwordControl.value) as string : user.password;

    const patchUser: User = { ...user, password };

    return this.userApi.put(patchUser);
  }

  resetFormConcrete() {
    return this.entityForm.reset();
  }
}
